import { render } from "./OrderMenu.vue?vue&type=template&id=e656701a"
import script from "./OrderMenu.vue?vue&type=script&lang=js"
export * from "./OrderMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__